import { createAction } from "redux-actions";

export const setValidatorsObjectProperties = createAction("SET_VALIDATORS_OBJECT_PROPERTIES");